import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import TimeAgo from "javascript-time-ago";
import logger from "./utils/logger";
import en from "javascript-time-ago/locale/en.json";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

TimeAgo.addDefaultLocale(en);

// Conditionally initialize Sentry only in production
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://9374e28c53ea9df3cc1485771aaa9300@o1420178.ingest.us.sentry.io/4507684479893504",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllText: false })],
    // Performance Monitoring
    tracesSampleRate: 0.2, // Sample 20% of transactions in production
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/.*\.megsapp\.com/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Listen for the reload message from the service worker
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data && event.data.type === "RELOAD_PAGE") {
        window.location.reload();
      }
    });

    navigator.serviceWorker.register("/service-worker.js").then((registration) => {
      // Check for updates every 5 minutes
      setInterval(
        () => {
          registration.update();
        },
        5 * 60 * 1000
      );

      // registration.addEventListener('controllerchange', () => {
      //   // Force reload when the service worker takes control
      //   window.location.reload();
      // });
    });
  });
}

// Route Web Vitals to Sentry as custom measurements
reportWebVitals((metric) => {
  if (!metric || typeof metric !== "object") return;
  if (import.meta.env.PROD && typeof Sentry !== "undefined") {
    try {
      Sentry.setMeasurement(metric.name, metric.value, metric.name === "CLS" ? "" : "millisecond");
    } catch (err) {
      // setMeasurement can throw when no active span/transaction (deprecated API)
      logger.warn("reportWebVitals: Failed to send metric to Sentry", { message: err?.message });
    }
  }
});
